/**
 * Cairn brand mark (§18) — a trail *cairn*: a small stack of balanced stones.
 * Geometric + monochrome; the top stone takes the accent so the logo carries
 * the one brand colour. Sizes via the `size` prop (px of the mark).
 */
export function CairnMark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {/* stacked stones, largest at the base, slightly offset for balance */}
      <rect x="4" y="17.5" width="16" height="4" rx="2" fill="var(--text-secondary)" />
      <rect x="6" y="12.5" width="12" height="4" rx="2" fill="var(--text)" />
      <rect x="8.5" y="8" width="7" height="3.6" rx="1.8" fill="var(--text)" />
      <rect x="9.5" y="3.4" width="5" height="3.4" rx="1.7" fill="var(--accent)" />
    </svg>
  );
}

/** Lockup: mark + wordmark. `subtitle` shows the product line under the name. */
export function BrandLockup({
  subtitle,
  size = 22,
}: {
  subtitle?: string;
  size?: number;
}) {
  return (
    <div className="brand">
      <CairnMark size={size} />
      <div className="brand__text">
        <span className="brand__name">Cairn</span>
        {subtitle ? <span className="brand__sub">{subtitle}</span> : null}
      </div>
    </div>
  );
}
